import * as React from 'react';
import { useDropzone } from 'react-dropzone';

function Dropzone({ reset, addJob, startConvert }) {
	const onDrop = React.useCallback(acceptedFiles => {
		reset();

		let fileCount: number = acceptedFiles.length;

		acceptedFiles.forEach(file => {
			const reader = new FileReader();
			reader.onabort = () => console.log('file reading was aborted');
			reader.onerror = () => console.log('file reading has failed');
			reader.onload = () => {
				addJob(file.name, reader.result);
				fileCount--;
				if (fileCount === 0) {
					startConvert();
				}
			};
			reader.readAsText(file);
		});
	}, []);
	const { getRootProps, getInputProps, isDragActive } = useDropzone({
		onDrop,
	});

	return (
		<div className="dropzone" {...getRootProps()}>
			<input {...getInputProps()} />
			{isDragActive ? (
				<div>파일을 이곳에 놓아주세요</div>
			) : (
					<div>광고관리자에서 추출된 CSV를 이곳에 드래그하거나 선택하세요</div>
				)}
		</div>
	);
}

export default Dropzone;



// WEBPACK FOOTER //
// ./src/dropzone.tsx